<template>
    <div class="panel-body" id="prices-panel">
        <div class="panel-nav">
            <button class="close-button" v-on:click.prevent="closePanel"></button>
        </div>
        <div class="scroller padded">
            <h2 class="panel-header"><img src="../assets/nav-prices.png" />Prezzi {{ (city) ? city.name : (state) ? state.name : country.value }}</h2>

            <loading-progress
                    :indeterminate="loading"
                    :hideBackground="true"
                    shape="line"
                    :size="loaderSize"
                    :width="loaderSize"
                    height="3"
            />

            <div class="placeholder-text" v-if="rows.length==0">Non ci sono dati</div>

            <div class="list-section" v-for="_row in rows">
                <span class="area" v-if="_row.area && rows.length>1">{{ _row.area }}</span>
                <ul id="news-list" :class="'list' + ((_row.area && rows.length>1) ? ' moved' : '')">
                    <li v-for="(_subrow, index) in _row.regions"
                        :class="'row-' + ((index % 2) ? 'odd' : 'even')">
                        <p v-on:click="goToArea(_subrow)" class="description">{{ _subrow.name }}</p>
                        <p v-on:click="goToArea(_subrow)" class="price">{{ _subrow.price }}</p>
                        <p v-on:click="goToArea(_subrow)" class="trend" :class="_subrow.trend"></p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

    import { serverBus } from '../main';
    import Api from "../api";
    import Levels from "../models/zoomlevels";

    export default {
        methods: {
            closePanel() {
                serverBus.$emit("closePanel");
            },
            goToArea(_area) {
                serverBus.$emit("goToArea", {
                    latLng: {
                        lat: parseFloat(_area.lat),
                        lng: parseFloat(_area.lng)
                    },
                    zoom: (this.city) ? 14 : Levels.getNextZoom((this.state) ? 'province' : 'region')
                });
            },
            loadData(_position) {
                //FIXME: prendo i parametri dal parent
                this.fuel = this.$parent.$parent.$parent.$parent.fuel;

                if(_position) {
                    this.country = _position.country;
                    this.state = _position.state;
                    this.city = _position.city;
                } else {
                    this.country = this.$parent.$parent.$parent.$parent.country;
                    this.state = this.$parent.$parent.$parent.$parent.state;
                    this.city = this.$parent.$parent.$parent.$parent.city;
                }

                var $scope = this;

                if(this.country && this.fuel) {
                    $scope.rows = [];

                    $scope.loading = true;

                    Api.getPrices(this.country.idstato,(this.state) ? this.state.id : null, (this.city) ? this.city.id : null,this.fuel,function(err,res){
                        $scope.rows = res;
                        $scope.loading = false;
                    });
                }

                serverBus.$on('loading', (loading) => {
                    $scope.loading = loading;
                });
            }
        },
        data() {
            return {
                fuel: null,
                country: null,
                state: null,
                city: null,
                rows: [],
                loading: false,
                loaderSize: 420
            };
        },
        created() {
            serverBus.$on('areaChanged',this.loadData);
            serverBus.$emit('pageChanged',{page:'MapPrices'});

            if(window.innerWidth < 480) {
                this.loaderSize = window.innerWidth - 60;
            }

            this.loadData(false);
        }
    }

</script>
<style scoped lang="scss">

    ul#news-list li{
        cursor: pointer;
    }

</style>
